import { NetworkErrorBanner } from './Banners';

export const ActivityUnassignBannerComponents = {
  NetworkErrorBanner,
};
